export const DROPBOX_BROCHURE_MANIFEST = {
  '2025-2026': {
    Amersham: [],
    Cardinal: [
      {
        fileName: 'Cardinal - December_and_January.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AMlzQsvSfH7G1w1wvxfvJF4/2025-2026/Cardinal/Cardinal%20-%20December_and_January.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'Cardinal - March 2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ANpP4klJhrzZVD0Me3O8lgY/2025-2026/Cardinal/Cardinal%20-%20March%202026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'Cardinal - November 2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AASysgDtx6QjU-gZVnqz50o/2025-2026/Cardinal/Cardinal%20-%20November%202025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'Cardinal - October 2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AAuI1IbQnG1yGV6PcJQa1Us/2025-2026/Cardinal/Cardinal%20-%20October%202025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'Cardinal - September 2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AA3WyJ0Da7EQPqaxhEOGaM8/2025-2026/Cardinal/Cardinal%20-%20September%202025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'CardinalFebruary2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ALZWIRZsVfK3lXVaPmsHqII/2025-2026/Cardinal/CardinalFebruary2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    Glasgow: [
      {
        fileName: 'GlasgowDecember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AEay6unUefbYYdYskeUPqZU/2025-2026/Glasgow/GlasgowDecember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'GlasgowFebruary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AOJbouyH8bNYa7e8-7VuNHU/2025-2026/Glasgow/GlasgowFebruary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'GlasgowJanuary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AAlT1j6usYeZzCLiu1z2XiY/2025-2026/Glasgow/GlasgowJanuary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'GlasgowMarch_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AIjmhzKx_S-j8x-JoS8V6bU/2025-2026/Glasgow/GlasgowMarch_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'GlasgowNovember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ANDv-aSaADCI_QSQ3Y3aSX8/2025-2026/Glasgow/GlasgowNovember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'GlasgowOctober_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ALWlCuWHZTDFBC5ZKUQahcY/2025-2026/Glasgow/GlasgowOctober_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'GlasgowSeptember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AP02ov9f5NPmqYx8hBWpRb8/2025-2026/Glasgow/GlasgowSeptember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    Guildford: [
      {
        fileName: 'GuildfordFebruary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ADrFUXTaxMdkmw4yfDi-YqU/2025-2026/Guildford/GuildfordFebruary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'GuildfordJanuary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ANytnNlee92xQ1TNvwLfBK8/2025-2026/Guildford/GuildfordJanuary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'GuildfordMarch_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ALxfvdkkHFk3dSCENnApJ-k/2025-2026/Guildford/GuildfordMarch_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'GuildfordNovemberDecember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AEeNlL3A-xIc6LPu6yGZeO8/2025-2026/Guildford/GuildfordNovemberDecember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'GuildfordOctober_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AChXpdaA2vWC4E5CvSWn_p8/2025-2026/Guildford/GuildfordOctober_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'GuildfordSeptember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ABUajg2CVUiytMP-5QO3RnE/2025-2026/Guildford/GuildfordSeptember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    Hillingdon: [
      {
        fileName: 'HillingdonFebruary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ALqKhSJCd9SQ2y5ZkZrkGeI/2025-2026/Hillingdon/HillingdonFebruary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'HillingdonJanuary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AO2zuzh_DY2ILM-iHuXEPQY/2025-2026/Hillingdon/HillingdonJanuary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'HillingdonNovemberDecember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AKF4KG6Z6kPunL5Af-ynZzs/2025-2026/Hillingdon/HillingdonNovemberDecember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'HillingdonOctober_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AFATjbnoxsLhpJWdQ7SOiO0/2025-2026/Hillingdon/HillingdonOctober_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'HillingdonSeptember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AHuHUcS85ucM7zapZEr4IOA/2025-2026/Hillingdon/HillingdonSeptember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    HollandPark: [
      {
        fileName: 'HollandParkDecemberJanuary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AJ7gLxclqQ_FSvgExwFhhkY/2025-2026/HollandPark/HollandParkDecemberJanuary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'HollandParkFebruary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ALwy4rj0QEuXzCz9pCDu6-U/2025-2026/HollandPark/HollandParkFebruary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'HollandParkNovember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AASiSjeDqCfpscVi2hFvPy0/2025-2026/HollandPark/HollandParkNovember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    Kingston: [
      {
        fileName: 'KingstonDecember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AAIvkDuGl685Coda0NkFM48/2025-2026/Kingston/KingstonDecember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'KingstonFebruary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/APSe3ahezwbQaQQxzRxWmPo/2025-2026/Kingston/KingstonFebruary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'KingstonJanuary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AI2pFvbqn2voLDqtlajcsGc/2025-2026/Kingston/KingstonJanuary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'KingstonNovember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AN6_JxCyb26Dxl3BI-Gohgw/2025-2026/Kingston/KingstonNovember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'KingstonOctober_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AJe4LRZd4OOd-Ii0DX12ZSQ/2025-2026/Kingston/KingstonOctober_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'KingstonSeptember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AMT3Hg1U2y7ydiN3ZXTGxYI/2025-2026/Kingston/KingstonSeptember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    Merton: [
      {
        fileName: 'MertonDecember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AEwnl0xDuIaExSzlHcteZuE/2025-2026/Merton/MertonDecember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'MertonFebruary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ALP8dL0Jj6vC5ihJdYFykiE/2025-2026/Merton/MertonFebruary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'MertonJanuary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AH5GcCIVjuJMDU5tox5pgf8/2025-2026/Merton/MertonJanuary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'MertonMarch_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AAQe_VhKj12tF9SfuaAvQAY/2025-2026/Merton/MertonMarch_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'MertonNovember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AI131wfFWBexW3JuulF7CkU/2025-2026/Merton/MertonNovember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'MertonOctober_2025 .pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AFC4FuCaSD4cnLS3R7VLqF0/2025-2026/Merton/MertonOctober_2025%20.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'MertonSeptember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AJZl_DqD1pTIjUMiXlm5QnE/2025-2026/Merton/MertonSeptember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    Northampton: [
      {
        fileName: 'NorthamptonJanuary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AMLZEdbRFKEsUaBJHIiJOb8/2025-2026/Northampton/NorthamptonJanuary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'NorthamptonMarch_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AFR3XICqaiztov39cGDJQco/2025-2026/Northampton/NorthamptonMarch_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'NorthamptonNovemberDecember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AL7uYej0QSUXzE9NDOIlMDc/2025-2026/Northampton/NorthamptonNovemberDecember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'NorthamptonOctober_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ABYgRQsN8Cth5J2edB_P16k/2025-2026/Northampton/NorthamptonOctober_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'NorthamptonSeptember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AMhSWMBazbMTXYS1hKZ4hXE/2025-2026/Northampton/NorthamptonSeptember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    Richmond: [
      {
        fileName: 'RichmondFebruary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AL1zwTxG1rNgLo3wUWU-exQ/2025-2026/Richmond/RichmondFebruary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'RichmondFebruary.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AC_9z8RxIWWjNmxS6szz61A/2025-2026/Richmond/RichmondFebruary.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'RichmondJanuary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AG9zi9BZT4qRtLo4kTDGECo/2025-2026/Richmond/RichmondJanuary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'RichmondNovemberDecember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AOAWBpV4BZvZ2cGq30m4vfs/2025-2026/Richmond/RichmondNovemberDecember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'RichmondOctober_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AMaeYJA2cUxi1T0E9Z-d0xY/2025-2026/Richmond/RichmondOctober_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'RichmondSeptember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AITGGuFpwHMK6Hr_IV7vul0/2025-2026/Richmond/RichmondSeptember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    Stratford: [
      {
        fileName: 'StratfordFebruary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ALXV_4isPU9VStIP-ytOpfs/2025-2026/Stratford/StratfordFebruary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'StratfordSeptember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AIbMQLDZ9QghMcP0G_6N_8Q/2025-2026/Stratford/StratfordSeptember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    TunbridgeWells: [
      {
        fileName: 'TunbridgeWellsFebruary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AGX-5wITvVvCMiz2p1IKq1Y/2025-2026/TunbridgeWells/TunbridgeWellsFebruary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'TunbridgeWellsMarch_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ABFbiEaaV2XHchoNCMvKsPw/2025-2026/TunbridgeWells/TunbridgeWellsMarch_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'TunbridgeWellsNovember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AL5cUqSwXWmzjedPeXWb-Gc/2025-2026/TunbridgeWells/TunbridgeWellsNovember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'TunbridgeWellsSeptemberOctober_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AAxivHY4Y7-ERkMlltQUW-k/2025-2026/TunbridgeWells/TunbridgeWellsSeptemberOctober_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    Wilberforce: [
      {
        fileName: 'WilberforceDecemberJanuary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AHFv-bWzEi1hnVm7PVg7ACE/2025-2026/Wilberforce/WilberforceDecemberJanuary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'WilberforceFebruary_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/APpy_9cLZsfKMkvHGVf0EsA/2025-2026/Wilberforce/WilberforceFebruary_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'WilberforceMarch_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AORa9U_8C8dkQaaPKiKTT7U/2025-2026/Wilberforce/WilberforceMarch_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'WilberforceNovember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AEvZrTDtz95bjSyS-VbsZ-0/2025-2026/Wilberforce/WilberforceNovember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'WilberforceOctober_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AMF3MhmctyUjduchC-5MTZs/2025-2026/Wilberforce/WilberforceOctober_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'WilberforceSeptember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ADPKbnPJHyacYCP8JxboyjE/2025-2026/Wilberforce/WilberforceSeptember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
    Woking: [
      {
        fileName: 'WokingDecember_2025.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/ALxurbH0BLMEqx5pQpMDkbo/2025-2026/Woking/WokingDecember_2025.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'WokingFebruary_2026 .pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AA3aolV1r1arL2N-9zk7JuE/2025-2026/Woking/WokingFebruary_2026%20.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'WokingJanuary_2026 .pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AKDQhVV7MtJXh65xsrBuu5Q/2025-2026/Woking/WokingJanuary_2026%20.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
      {
        fileName: 'WokingMarch_2026.pdf',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/b0gl5a2qcrz31khb458wm/AAFD3O_R0Olp6r6esGyE04Y/2025-2026/Woking/WokingMarch_2026.pdf?rlkey=jh8upjj94s042wvhj2zafbrov&dl=0',
      },
    ],
  },
};
